// router/index.js
import React from "react";

const routes = [
  {
    path: "/",
    breadcrumb: "集團介紹",
    component: React.lazy(() => import("../views"))
  },
  {
    path: "/intro",
    breadcrumb: "企業理念",
    component: React.lazy(() => import("../views/philosophy"))
  },
  {
    path: "/dev",
    breadcrumb: "集團發展",
    component: React.lazy(() => import("../views/development"))
  },
  {
    path: "/privacy-policy",
    breadcrumb: "隱私權保護政策",
    component: React.lazy(() => import("../views/privacy"))
  },
  {
    path: "/terms-use",
    breadcrumb: "使用者規範",
    component: React.lazy(() => import("../views/terms-use"))
  },
  {
    path: "/motel",
    breadcrumb: "形象官網",
    component: React.lazy(() => import("../views/motel"))
  },
  {
    path: "/motel/aboutus",
    breadcrumb: "關於我們",
    component: React.lazy(() => import("../views/motel/aboutUs"))
  },
  {
    path: "/motel/intro/linkou",
    breadcrumb: "各館介紹 - 林口館",
    component: React.lazy(() => import("../views/motel/intro/linkou"))
  },
  {
    path: "/motel/event",
    breadcrumb: "活動優惠",
    component: React.lazy(() => import("../views/motel/event"))
  },
  {
    path: "/motel/attractions/linkou",
    breadcrumb: "周邊景點 - 林口館",
    component: React.lazy(() => import("../views/motel/attractions"))
  },
  {
    path: "/motel/faq/",
    breadcrumb: "常見問題 - 訂房常見問題",
    component: React.lazy(() => import("../views/motel/faq"))
  },
  {
    path: "/motel/notice",
    breadcrumb: "各館介紹 - 林口館",
    component: React.lazy(() => import("../views/motel/notice"))
  },
  {
    path: "/hotel",
    breadcrumb: "訂房服務",
    component: React.lazy(() => import("../views/hotel/main"))
  },
  {
    path: "/hotel/stay", // stayType: stay / rest
    breadcrumb: "住宿", // 休息
    component: React.lazy(() => import("../views/hotel/main"))
  },
  {
    path: "/hotel/rest",
    breadcrumb: "休息",
    component: React.lazy(() => import("../views/hotel/main"))
  },
  // {
  //   path: "/hotel/:stayType/hotels",
  //   breadcrumb: "搜尋結果",
  //   component: React.lazy(() => import("../views/hotel/hotels")),
  // },
  // {
  //   path: "/hotel/:stayType/:hotelId",
  //   breadcrumb: "預訂XX館",
  //   component: React.lazy(() => import("../views/hotel/rooms")),
  // },
  // {
  //   path: "/hotel/:stayType/:hotelId/book/:roomId",
  //   breadcrumb: "1.住客資料",
  //   component: React.lazy(() => import("../views/hotel/book/step1")),
  // },
  // {
  //   path: "/hotel/:stayType/:hotelId/pay/:roomId", //  下拉 payMethod = credit / atm / mart-code 
  //   breadcrumb: "2.付款資料",  // 全付 / 預付
  //   component: React.lazy(() => import("../views/hotel/book/step2")),
  // },
  // {
  //   path: "/hotel/:stayType/:hotelId/finish/:roomId", // result
  //   breadcrumb: "3.預訂成功",  // 預訂成功
  //   component: React.lazy(() => import("../views/hotel/book/step3")),
  // },
];

export default routes;
